module.exports = __webpack_public_path__ + "static/media/overview5_1.291c9bd2.png";